module.exports = __webpack_public_path__ + "img/sgplhc_icon.1ee08548.png";